// The step function failure `cause` is usually a JSON blob
// ({errorMessage, errorType, stackTrace}). Pull out errorMessage, falling back
// to the raw string so we never hide an unparseable error.
export function extractRedriveErrorMessage(
  cause: string | undefined | null
): string | null {
  if (!cause) {
    return null;
  }
  const raw = cause.trim();
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.errorMessage === "string" && parsed.errorMessage.trim()) {
      return parsed.errorMessage;
    }
  } catch {
    // Not JSON — fall through to the raw string.
  }
  return raw;
}
